import React from "react";
import EwaybillAccountTable from "./components/EwaybillAccountTable";
import OperationContainer from "./components/OperationContainer";
import ModalStoreProvider from "@/hooks/Modal/ModalStoreProvider";
import { useModalStore } from "@/hooks/Modal/hooks";
import { getEwaybillAccountListWithExpiredInfo, syncEwaybillAccountV2 } from "@/services/api/ewaybillAccount";
import { useRequest } from "ahooks";
import { Card, message } from "antd";
import SyncResultModal from "./components/SyncResultModal";
import CallBackMessageAlert from "./components/CallbackMessageAlert";

interface EwaybillAccountProps {}

const _EwaybillAccount: React.FC<EwaybillAccountProps> = function (props) {
  const modalStore = useModalStore();

  const { data, loading, refresh } = useRequest(async () => {
    return getEwaybillAccountListWithExpiredInfo();
  });

  return (
    <Card>
      <CallBackMessageAlert />

      <OperationContainer
        onSync={async () => {
          const result = await syncEwaybillAccountV2();

          if (result.allSuccess) {
            message.success("全部电子面单同步成功");
          } else {
            modalStore.openModal(SyncResultModal, {
              dataSource: result.items,
            });
          }
          refresh();
        }}
      />

      <EwaybillAccountTable info={data} loading={loading} />
    </Card>
  );
};

const EwaybillAccount: React.FC<EwaybillAccountProps> = function (props) {
  return (
    <ModalStoreProvider>
      <_EwaybillAccount />
    </ModalStoreProvider>
  );
};

export default React.memo(EwaybillAccount);
